import type { BadgeStatusVariant } from "@woba/ds-web-next";

/**
 * Variante do BadgeStatus do Workbase DS para cada tipo de produto
 * (productTypeIds), conforme a legenda do Figma (6038:3550 / 6061:4445).
 */
const PRODUCT_BADGE_STATUS_VARIANT: Record<number, BadgeStatusVariant> = {
  1: "info", // Compartilhado
  3: "success", // Exclusivo
  4: "warning", // Reunião
  5: "critical", // Eventos
  6: "neutral", // Privativo
};

export const productBadgeVariant = (type: number): BadgeStatusVariant =>
  PRODUCT_BADGE_STATUS_VARIANT[type] ?? "neutral";

/**
 * Cor da linha/área de cada produto no gráfico: o mesmo valor (tema claro) de
 * `--woba-color-content-feedback-<variante>`, que é a cor do ponto do
 * BadgeStatus na legenda. Hex porque o recharts escreve a cor em atributos SVG
 * (stroke/stop-color), onde `var()` não é resolvido.
 */
const FEEDBACK_CONTENT_HEX: Record<BadgeStatusVariant, string> = {
  info: "#006BB2", // --woba-color-light-blue-700
  success: "#207C0E", // --woba-color-light-green-700
  warning: "#A84600", // --woba-color-light-orange-700
  critical: "#991200", // --woba-color-light-red-800
  neutral: "#4A3E1C", // --woba-color-light-sand-900
};

export const productSeriesColor = (type: number): string =>
  FEEDBACK_CONTENT_HEX[productBadgeVariant(type)];
